export const PLAYBACK_MODES = {
  ALL: 'all',
  SENTENCE: 'sentence',
  ONCE: 'once',
} as const

export type PlaybackMode = (typeof PLAYBACK_MODES)[keyof typeof PLAYBACK_MODES]

export const SHOW_TEXT_MODES = {
  FULL: 'full',
  HIDDEN: 'hidden',
  TEXT_ONLY: 'text-only',
} as const

export type ShowTextMode = (typeof SHOW_TEXT_MODES)[keyof typeof SHOW_TEXT_MODES]
